import { Typography } from "antd";
import { iTag } from "../../utils/searchPrompt";

const Template1 = ({ value }) => {
  // Extract the key from the value prop
  const key = Object.keys(value)[0];

  // Find the matching entry in the iTag array
  const match = iTag.find((item) => item.key === key);
  const itags = match?.itags ? match.itags.split("|") : [];

  // Split the URLs if they exist
  // const urls = match?.urls ? match.urls.split("|") : [];
  const references =
    match?.urls &&
    match?.urls?.split("|")?.map((ref) => {
      const colonIndex = ref.indexOf(":");
      if (colonIndex !== -1) {
        const label = ref?.substring(0, colonIndex)?.trim();
        const url = ref?.substring(colonIndex + 1)?.trim();
        return { label, url };
      } else {
        return { label: "", url: ref?.trim() };
      }
    });
  return (
    <div className="border px-[13px] py-[10px]">
      <div className=" max-w-[450.63px]">
        <div className="flex flex-col items-center gap-4">
          <div className="capitalize flex justify-center items-start text-[#2F2F2F] font-[700] text-[18px] leading-[15.78px]">
            {key === "ingredients__and__processing"
              ? "Ingredients"
              : key?.replace(/_/g, " ")}
          </div>
          {/* <Image src={infoModals} width={100} height={100} /> */}
          <ul className="list-disc pl-4">
            {itags.map((tag, index) => (
              <li
                key={index}
                className="text-[#1D1D1D] font-[400] text-[14px] leading-[17px]"
              >
                {tag.trim()}
              </li>
            ))}
          </ul>
          <div className="border-t-2 w-full h-[2px]"></div>
          <div className="flex flex-row items-center w-full gap-1">
            <div>
              <Typography.Text className="text-[#1D1D1D] font-[700] text-[14px] leading-[16.8px] capitalize">
                Ref:
              </Typography.Text>
            </div>
            <div>
              <div className="font-[500] text-[14px] leading-[15.78px]">
                <div className="text-[#2F2F2F] font-[500] text-[14px] leading-[18.41px] capitalize">
                  {references.map((ref) => ref.label).join(", ")}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Template1;
